<script setup lang="ts">
import { useToastStore } from "../data/store.ts";

const { toasts, clearToast } = useToastStore();
</script>

<template>
  <div
    class="position-absolute d-flex flex-column"
    style="width: 200px; top: 1rem; right: 1rem"
  >
    <div
      v-for="toast in toasts"
      :key="toast.idx"
      :class="{
        'text-bg-success': toast.typ == 'SUCC',
        'text-bg-danger': toast.typ == 'FAIL',
        'text-bg-warning': toast.typ == 'WARN',
        'text-bg-info': toast.typ == 'INFO',
      }"
      class="card mb-2 p-2"
      @click="clearToast(toast.idx)"
    >
      {{ toast.msg }}
    </div>
  </div>
</template>

<style scoped></style>
